import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const AfterAcceptance = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">After acceptance</h2>
      <hr />

      <p className="joab-common-para my-2 ">
        The corresponding author will receive communication of the articles for
        approval and final sign-off of the editorial process.
      </p>
    </Container>
  );
};

export default AfterAcceptance;
